import React, { Component } from 'react';
import { connect } from 'react-redux';
import AccountUserRankListWrap from '../../../views/account/user/rank/AccountUserRankListWrap';
import { accountUserActions } from '../../../store/modules/account/user';
import { message } from 'antd';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../constants/service/common/utilConstants';

class AccountUserRankListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    // 초기 시작에 리스트를 호출하지 않음
  };

  getList = (data) => {
    const { getAccountUserRankList, accountUserRankList } = this.props;
    const { searchOption, sortOption, pagination } = accountUserRankList;

    getAccountUserRankList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getAccountUserRankExcelDownload, pageName, accountUserRankList } = this.props;

    if (!accountUserRankList || !accountUserRankList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getAccountUserRankExcelDownload({
      searchOption: accountUserRankList.searchOption,
      sortOption: accountUserRankList.sortOption,
      userPageName: pageName,
    });
  };

  render() {
    const { accountUserRankList } = this.props;

    return (
      <AccountUserRankListWrap
        accountUserRankList={accountUserRankList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    accountUserRankList: state.accountUser.accountUserRankList,
  };
};

const mapDispatchToProps = {
  getAccountUserRankList: accountUserActions.getAccountUserRankList,
  getAccountUserRankExcelDownload: accountUserActions.getAccountUserRankExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountUserRankListContainer);
